module.exports = __webpack_public_path__ + "img/overexplainer.a8521ba5.png";